import * as React from 'react'
import styled from 'styled-components'
import { Button } from '../../UI/Button'
import { DropdownSlide } from './DropdownSlide'
import CustomLink from '../../CustomLink'

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
`

export interface DropdownLinkProps {
  content?: any[]
  label: string
  onClick: () => void
  parentIsOpen?: boolean
  to: string
}

export const DropdownLink = ({ label, to, onClick, content, parentIsOpen }: DropdownLinkProps) => {
  const [isOpen, setIsOpen] = React.useState(false)
  const hasDropdown = content && content.length > 0

  const onClickHandler = React.useCallback(() => {
    if (!hasDropdown) {
      onClick()
    } else {
      setIsOpen(true)
    }
  }, [onClick, hasDropdown])

  React.useEffect(() => {
    if (!parentIsOpen) {
      setIsOpen(false)
    }
  }, [parentIsOpen])

  return (
    <>
      <ButtonWrapper>
        <Button
          as={!hasDropdown ? CustomLink : undefined}
          to={to}
          onClick={onClickHandler}
          $variant="tertiary"
          $size="small"
          $ignoreTheme
        >
          {label}
        </Button>
      </ButtonWrapper>
      {hasDropdown && (
        <DropdownSlide
          onCloseMenu={onClick}
          content={content}
          title={label}
          isOpen={isOpen}
          onClose={() => setIsOpen(false)}
        />
      )}
    </>
  )
}
